import { render, staticRenderFns } from "./XGridChild.vue?vue&type=template&id=6323a5f2&scoped=true&"
import script from "./XGridChild.vue?vue&type=script&lang=js&"
export * from "./XGridChild.vue?vue&type=script&lang=js&"
import style0 from "./XGridChild.vue?vue&type=style&index=0&id=6323a5f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6323a5f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6323a5f2')) {
      api.createRecord('6323a5f2', component.options)
    } else {
      api.reload('6323a5f2', component.options)
    }
    module.hot.accept("./XGridChild.vue?vue&type=template&id=6323a5f2&scoped=true&", function () {
      api.rerender('6323a5f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grid/XGridChild.vue"
export default component.exports